/* vim: set expandtab sw=2 ts=2 sts=2: */
import React from 'react'
import ProductsContainer from './ProductsContainer'
import CartContainer from './CartContainer'

const ShoppingCart = () => (
  <div>
    <h2>Shopping Cart Example</h2>
    <hr/>
    <ProductsContainer />
    <hr/>
    <CartContainer />
  </div>
)

export default ShoppingCart



// WEBPACK FOOTER //
// ./usr/lib/ui/src/containers/shop-cart/index.js